// Sticky buy bar: shows once the product form's main add-to-cart button has scrolled above the viewport, hides again when it returns. Re-binds automatically because the bar re-renders with the product-form partial on variant change.
class StickyBuy extends HTMLElement {
  #observer;

  connectedCallback() {
    const form = this.closest('form');
    const mainButton = form?.querySelector('[data-main-add]');
    if (!mainButton || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-show', scrolledPast);
      this.inert = !scrolledPast;
    });
    this.#observer.observe(mainButton);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', StickyBuy);
